import { TextButton } from "@/components/button/text-button";
import { PageContainer } from "@/components/container/page-container";
import { BarcodeIcon } from "@/components/icons/barcode-icon";
import { CameraIcon } from "@/components/icons/camera-icon";
import { LinkSimpleIcon } from "@/components/icons/link-simple-icon";
import { PencilSimpleIcon } from "@/components/icons/pencil-simple-icon";
import { SearchIcon } from "@/components/icons/search-icon";
import { SmileIconWithShadow } from "@/components/icons/smile-icon-with-shadow";
import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { OnboardingRoundBackground } from "@/features/user-profile/components/onboarding-round-background";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useIonRouter } from "@ionic/react";

function OnboardingAddFood() {
  const navigation = useIonRouter();

  const handleAddFoodsNow = () => {
    navigation.push("/profiling/step-building-screen", "forward");
  };

  const handleAddLater = () => {
    navigation.push("/profiling/step-building-screen", "forward");
  };

  const addFoodOptions = [
    {
      icon: SearchIcon,
      label: "Search",
    },
    {
      icon: LinkSimpleIcon,
      label: "Add from a link",
    },
    {
      icon: CameraIcon,
      label: "Take a photo of a recipe",
    },
    {
      icon: PencilSimpleIcon,
      label: "Add manually",
    },
    {
      icon: BarcodeIcon,
      label: "Scan a barcode",
    },
  ];

  return (
    <PageContainer showToolbar={false}>
      <OnboardingRoundBackground
        classNames={{
          container: "bg-screen-gs-1 space-y-17",
          header: "flex flex-col items-center pt-[88px] pt-12 px-8",
          content:
            "w-full flex flex-col justify-end items-center px-8 pt-8 pb-12 gap-12",
        }}
        header={
          <>
            <div className="mb-4">
              <SmileIconWithShadow />
            </div>
            <h1 className={cn(textVariants.title1, "text-white text-center")}>
              Add your personal foods to make the plan your own!
            </h1>
          </>
        }
      >
        <div className="space-y-2">
          {addFoodOptions.map((option, index) => {
            const Icon = option.icon;
            return (
              <div key={index} className="flex items-center gap-2">
                <Icon className="w-6 h-6" />
                <p
                  key={index}
                  className={cn(textVariants.bodySingleLine, "text-black")}
                >
                  {option.label}
                </p>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col gap-4 w-full">
          <FilledButton
            color="black"
            textCase="uppercase"
            onClick={handleAddFoodsNow}
          >
            Add foods now
          </FilledButton>

          <TextButton text="Add later" onClick={handleAddLater} />
        </div>
      </OnboardingRoundBackground>
    </PageContainer>
  );
}

export default OnboardingAddFood;
